export default __webpack_public_path__ + "static/media/Triggers - Anger worksheet.20e78541.pdf";